import c from './Landing.module.css';
import { CONTACT } from './data';

export function Contact() {
  return (
    <section id="contact" className={c.contact}>
      <div className={c.contactGlow} />
      <div className={`${c.container} ${c.contactInner}`}>
        <div className={c.eyebrow}>05 — CONTACT</div>
        <h2 className={c.h2xl}>Have a project <span className={c.gradientText}>in mind?</span></h2>
        <p className={c.contactText}>Tell us what you're building and we'll come back with a scoped first milestone.</p>
        <div className={c.contactCtas}>
          <a href={`mailto:${CONTACT.email}`} className={c.btnPrimary}>{CONTACT.email}</a>
          <a href={CONTACT.phoneHref} className={`${c.btnSecondary} ${c.btnPhone}`}>{CONTACT.phoneDisplay}</a>
        </div>
      </div>
    </section>
  );
}
